var map = {
	"./access-denied/access-denied.module": [
		"../../../../../src/app/main/content/apps/access-denied/access-denied.module.ts",
		"access-denied.module",
		"common"
	],
	"./banner-reviews/banner-reviews.module": [
		"../../../../../src/app/main/content/apps/banner-reviews/banner-reviews.module.ts",
		"banner-reviews.module"
	],
	"./calendar/calendar.module": [
		"../../../../../src/app/main/content/apps/calendar/calendar.module.ts",
		"calendar.module"
	],
	"./configuration/configuration.module": [
		"../../../../../src/app/main/content/apps/configuration/configuration.module.ts",
		"configuration.module",
		"common"
	],
	"./configuration/market-company-affiliate/market-company-affiliate.module": [
		"../../../../../src/app/main/content/apps/configuration/market-company-affiliate/market-company-affiliate.module.ts",
		"market-company-affiliate.module"
	],
	"./contacts/contacts.module": [
		"../../../../../src/app/main/content/apps/contacts/contacts.module.ts",
		"contacts.module"
	],
	"./e-commerce/e-commerce.module": [
		"../../../../../src/app/main/content/apps/e-commerce/e-commerce.module.ts"
	],
	"./main/content/apps/apps.module": [
		"../../../../../src/app/main/content/apps/apps.module.ts"
	],
	"./permission/permission.module": [
		"../../../../../src/app/main/content/apps/permission/permission.module.ts",
		"permission.module",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main